import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import filterStyles from '../filters.scss'
import styles from './AddToCollectionMenu.scss'
import { CheckboxGroup } from 'common/styleguide/CheckboxGroup'
import { CREATE_EDIT_COLLECTION_DIALOG } from 'common/modals/CreateEditCollection'
import { showModal } from 'lib/modalUtils'
import { Msg } from 'lib/localization'
import { collectionActions } from 'data/resources/collections'
import { injectIntl, defineMessages } from 'react-intl'
import { Set, OrderedMap } from 'immutable'
import _ from 'lodash'

const messages = defineMessages({
  addToCollection: {
    id: 'AddToCollectionMenu.addToCollection',
    defaultMessage: 'Add to Collection'
  },
  newCollection: {
    id: 'AddToCollectionMenu.newCollection',
    defaultMessage: 'New Collection'
  }
})

export class _AddToCollectionMenu extends React.PureComponent {
  state = {
    selected: Set()
  }

  newCollection = () => {
    const { toggleExpand, troutes, objectType, intl } = this.props

    toggleExpand()
    showModal(CREATE_EDIT_COLLECTION_DIALOG, {
      modalTitle: intl.formatMessage(messages.newCollection),
      itemsToAdd: troutes,
      itemType: objectType
    })
  }

  render () {
    const { onApply, collections } = this.props
    const { selected } = this.state

    return (
      <Fragment>
        <CheckboxGroup
          className={styles.group}
          options={OrderedMap(_.fromPairs(collections.valueSeq().map(c => [c.id, c.title]).toJS()))}
          selected={selected}
          onChange={(value) => this.setState({ selected: value })}
          radioClass={styles.radioClass}
          horizontal
        />
        <div className={styles.buttons}>
          <a className={selected.size > 0 ? filterStyles.apply : filterStyles.disabled} onClick={() => selected.size > 0 && onApply(selected)}><Msg m={messages.addToCollection} /></a>
          <a className={filterStyles.apply} onClick={() => this.newCollection()}><Msg m={messages.newCollection} /></a>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userId } = ownProps
  return {
    collections: state.apiv3.collection.id.filter(c => c.userId === userId)
  }
}

const mapDispatchToProps = {
  createCollection: collectionActions.create
}

export const AddToCollectionMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(_AddToCollectionMenu))
